import * as React from 'react';
import styled from 'styled-components';
import { TextLink } from '../Text';
import { FlexRowCenterVertical } from '../Flexbox/Flexbox';

export const PdfLink = ({ url, name }) => {
  return (
    <FlexRowCenterVertical>
      <PdfIcon src={'/images/mimes/pdf.svg'} alt={name} />
      <TextLink href={url} target="_blank">
        {name}
      </TextLink>
    </FlexRowCenterVertical>
  );
};

const PdfIcon = styled.img`
  width: 28px;
`;
